import { Component, OnInit } from '@angular/core';
import { AsociacionJefeDependenciaService, CateringUnidadService, DisponibilidadService } from 'npm-servicios-catering';
import { Subscription } from 'rxjs';
import { Constantes } from '../../../compartido/constantes/constantes';
import { ActivatedRoute } from '@angular/router';
import { AsociacionPersonaDTO } from '../../../compartido/modelado-compartido/asociacionPersonaDTO';
import { Unidad } from "modelo-unidad-servicio-sga";
import { Router } from '@angular/router';
import { LoadingPage } from '../../../compartido/cargando/loading';
import { ConfirmationService } from 'primeng/api';
import { AsociacionPersona, TipoPersona } from 'npm-modelado-catering';
import { environment } from '../../../../environments/environment';
import { Usuario } from '../../modelado/sar/usuario';
import { UsuarioXRolXUnidadDTO } from '../../modelado/sar/usuario-x-rol-x-unidad-DTO';
import { UsuarioXRolXUnidad } from '../../modelado/sar/usuario-x-rol-x-unidad';
import { UnidadAdministrativa } from '../../modelado/sar/unidad-administrativa';
import { Persona } from '../../../compartido/modelado-compartido/persona';

@Component({
  selector: 'app-asociar-jefe-dependencia',
  templateUrl: './asociar-jefe-dependencia.component.html',
  styleUrls: ['./asociar-jefe-dependencia.component.css']
})
export class AsociarJefeDependenciaComponent extends LoadingPage implements OnInit {

  lstRespuesta: String[];
  lstAsociacionPersonaJefesUnidadDTO: AsociacionPersonaDTO[];
  jefeUnidadSeleccionado: AsociacionPersonaDTO;
  personaGuardar: AsociacionPersona = {};

  usuarioGAS: Usuario;//usuario para el micro del gas
  usuarioPorLdapUid: Usuario;
  posArrayUsuarioAsociar: number = -1;

  listaUsuarioXRolResponse: UsuarioXRolXUnidad[] = [];
  listaUsuarioXRol: UsuarioXRolXUnidad[] = [];
  guardarNodosUnidad: UnidadAdministrativa[] = []; //Son los nodos para guardar
  lista: UnidadAdministrativa[];//lista de unidades
  unidadAministrativaActivar: UnidadAdministrativa;
  // ===============  Nodos para Unidad ===========
  opcionClick: number = 0;// 1=eliminar 2=activar 3=desactivar

  tipoP: TipoPersona = {};
  unidadTemp: Unidad;

  busy: Subscription;
  lstPersonasResultados: Persona[] = [];
  lstPersonasResultadosAdministrativos: Persona[];
  lstPersonasResultadosDocentes: Persona[];
  flagEncuentraPersona: boolean = false;
  loadingBusqueda: boolean;

  constructor(private routerParams: ActivatedRoute,
    private asociacionJefeDependenciaService: AsociacionJefeDependenciaService,
    private cateringUnidadService: CateringUnidadService, private disponibilidadService: DisponibilidadService, private router: Router,
    private confirmationService: ConfirmationService
  ) {
    super(false);
  }

  ngOnInit() {
    this.cargarEnviroment();
    this.obtenerJefesUnidad();
  }
  obtenerJefesUnidad() {
    this.busy = this.asociacionJefeDependenciaService.listarTipoAsociacionPersona(1).then(jefesUnidad => {//Enviamos 1 ya que es el id del tipo "jefe de unidad"
      if (jefesUnidad) {
        this.lstAsociacionPersonaJefesUnidadDTO = jefesUnidad;
        this.lstAsociacionPersonaJefesUnidadDTO.forEach(jefeU => {
          jefeU.estadoDependencia = this.parseEstado(jefeU.estaActivoParaDependencia);
        });
      }
    }).catch(error => {
      this.mostrarMensajeError(error);
    });
  }
  cargarEnviroment() {
    this.asociacionJefeDependenciaService.set_constantes(Constantes);

  }
  seleccionarJefeUnidad() {

  }
  agregarClick() {

    this.router.navigate(['/configuracion/agregar-jefe-dependencia-crear']);
  }

  editarClick() {
    if (this.jefeUnidadSeleccionado && this.jefeUnidadSeleccionado.idAsociacionPersona) {
      this.router.navigate(['/configuracion/agregar-jefe-dependencia-editar/', this.jefeUnidadSeleccionado.idAsociacionPersona]);
    } else {
      this.mostrarMensajeInfo(this._noObjetoGrillaEditar);
    }
  }
  eliminarClick() {

    if (!this.jefeUnidadSeleccionado) {
      this.mostrarMensajeInfo(this._noObjetoGrillaEditar);
    } else {
      this.opcionClick = 1;//esta activado el eliminar
      const urlUsuario = environment.URL_USUARIO;

      this.busy = this.asociacionJefeDependenciaService.buscarPorLdapUid(urlUsuario, this.lstPersonasResultados[0].correoInstitucional.substring(0, this.lstPersonasResultados[0].correoInstitucional.indexOf("@"))).then(async responseU => {
        if (responseU) {
          console.log(responseU);
          this.usuarioGAS = responseU;

          this.busy = this.asociacionJefeDependenciaService.buscarPorLdapUid(urlUsuario, this.usuarioGAS.ldapUid).then(responseU => {
            if (responseU) {
              console.log(responseU);
              this.usuarioPorLdapUid = responseU;
              const URL_USUARIOXROLXUNIDAD = environment.URL_USUARIOXROLXUNIDAD;
              this.busy = this.cateringUnidadService.buscarPorIdAplicativoPorIdUsuario(URL_USUARIOXROLXUNIDAD, environment.APP_ID, this.usuarioPorLdapUid.idUsuario).then(
                resp => {
                  this.listaUsuarioXRol = [];
                  this.ready();
                  this.listaUsuarioXRolResponse = resp;
                  for (let index = 0; index < this.listaUsuarioXRolResponse.length; index++) {
                    const objUsuaraioXRol: UsuarioXRolXUnidad = this.listaUsuarioXRolResponse[index];

                    if (objUsuaraioXRol.idRol == environment.ROL_JEFE_DEPENDENCIA_ID) {
                      this.listaUsuarioXRol.push(objUsuaraioXRol);
                      console.log("Push");
                    }
                  }

                  if (this.jefeUnidadSeleccionado && this.jefeUnidadSeleccionado.idAsociacionPersona) {
                    this.confirmationService.confirm({
                      key: 'autorizacion',
                      header: this._eliminarJefeDependencia,
                      message: '¿Está seguro que desea eliminar el jefe de dependencia seleccionado?',
                      accept: () => {
                        this.eliminarJefeDependencia();
                      }
                    });
                  } else {
                    this.mostrarMensajeInfo(this._noObjetoGrillaEliminar);
                  }

                }, error => {
                  console.error(error);
                  this.ready();
                }
              );



            } else {
              this.mostrarMensajeError("No es posible continuar, el usuario no existe en el Sistema GAS, comuníquese con la Dirección de Tecnologías");
            }
          }).catch(error => {
            this.mostrarMensajeError(error);
          });
        } else {

          this.mostrarMensajeError("No es posible continuar, el usuario no existe en el Sistema GAS, comuníquese con la Dirección de Tecnologías");
        }
      }).catch(error => {
        this.mostrarMensajeError(error);
      });
    }

  }
  eliminarJefeDependencia() {
    this.jefeUnidadSeleccionado.estaActivoParaDependencia = this.jefeUnidadSeleccionado.estaActivoParaDependencia;
    this.personaGuardar.idAsociacionPersona = this.jefeUnidadSeleccionado.idAsociacionPersona;
    this.personaGuardar.idDependencia = this.jefeUnidadSeleccionado.idUnidad + "";
    this.personaGuardar.idPersona = this.jefeUnidadSeleccionado.idPersona;
    this.personaGuardar.estaActivo = "N";
    this.tipoP.idTipoPersona = 1;
    this.personaGuardar.tipoPersona = this.tipoP;
    this.personaGuardar.estaActivoParaDependencia = "N";
    this.personaGuardar.fechaCreacion = this.jefeUnidadSeleccionado.fechaCreacion;
    this.personaGuardar.usuarioCreacion = this.jefeUnidadSeleccionado.usuarioCreacion;

    this.busy = this.asociacionJefeDependenciaService.actualizar(this.personaGuardar).then(async asociacion => {
      if (asociacion) {
        this.guardarNodosUnidad=[];
        await this.cargaNodosParaEditarELiminar();
        this.asignaElRolyUnidad();


      }
    }).catch(error => {
      this.mostrarMensajeError(error);
    });
  }

  cargaNodosParaEditarELiminar() {

    for (let index = 0; index < this.listaUsuarioXRol.length; index++) {
      console.log("Ingresa x");
      const objUsuaraioXRol: UsuarioXRolXUnidad = this.listaUsuarioXRol[index];

      if (objUsuaraioXRol.unidadAdministrativa.idUnidad != Number(this.personaGuardar.idDependencia)) {//excluye a la dependencia seleccionada
        this.guardarNodosUnidad.push(objUsuaraioXRol.unidadAdministrativa);
        console.log("Push guarda anteriores");
      } else {
        console.log("Encuentra para no considerar " + this.personaGuardar.idDependencia);
      }
    }
  }

  cargaNodosParaActivar() {


    for (let index = 0; index < this.listaUsuarioXRol.length; index++) {
      const objUsuaraioXRol: UsuarioXRolXUnidad = this.listaUsuarioXRol[index];
      this.guardarNodosUnidad.push(objUsuaraioXRol.unidadAdministrativa);
      console.log(this.guardarNodosUnidad.length + " tamaño carga " + this.listaUsuarioXRol.length);
    }

  }


  parseEstado(abEstado) {
    if (abEstado) {

      if (abEstado === "S") {
        return "ACTIVO";
      } else {
        return "INACTIVO";
      }
    }
    return "";

  }

  activarClick() {
    if (!this.jefeUnidadSeleccionado) {
      this.mostrarMensajeInfo(this._noObjetoGrillaActivar);
    } else {
      if (this.jefeUnidadSeleccionado.estaActivoParaDependencia.localeCompare("S") == 0) {
        this.mostrarMensajeInfo("El registro yá se encuentra activo");
        console.log(this.jefeUnidadSeleccionado.estaActivoParaDependencia);
      } else {
        this.opcionClick = 2;//esta activado el activar
        const urlUsuario = environment.URL_USUARIO;

        this.busy = this.asociacionJefeDependenciaService.buscarPorLdapUid(urlUsuario, this.lstPersonasResultados[0].correoInstitucional.substring(0, this.lstPersonasResultados[0].correoInstitucional.indexOf("@"))).then(async responseU => {
          if (responseU) {
            console.log(responseU);
            this.usuarioGAS = responseU;

            this.busy = this.asociacionJefeDependenciaService.buscarPorLdapUid(urlUsuario, this.usuarioGAS.ldapUid).then(responseU => {
              if (responseU) {
                console.log(responseU);
                this.usuarioPorLdapUid = responseU;
                console.log(" usu " + this.usuarioPorLdapUid.correo + " -- " + this.usuarioPorLdapUid.idUsuario);
                const URL_USUARIOXROLXUNIDAD = environment.URL_USUARIOXROLXUNIDAD;
                this.busy = this.cateringUnidadService.buscarPorIdAplicativoPorIdUsuario(URL_USUARIOXROLXUNIDAD, environment.APP_ID, this.usuarioPorLdapUid.idUsuario).then(
                  resp => {
                    this.listaUsuarioXRol = [];
                    this.ready();
                    this.listaUsuarioXRolResponse = resp;
                    for (let index = 0; index < this.listaUsuarioXRolResponse.length; index++) {
                      const objUsuaraioXRol: UsuarioXRolXUnidad = this.listaUsuarioXRolResponse[index];

                      if (objUsuaraioXRol.idRol == environment.ROL_JEFE_DEPENDENCIA_ID) {
                        this.listaUsuarioXRol.push(objUsuaraioXRol);
                        console.log("Push");
                      }
                    }

                    if (this.jefeUnidadSeleccionado && this.jefeUnidadSeleccionado.idAsociacionPersona) {
                      this.confirmationService.confirm({
                        key: 'autorizacion',
                        header: "Activar jefe de dependencia",
                        message: '¿Está seguro que desea activar el jefe de dependencia seleccionado?',
                        accept: () => {
                          this.guardarNodosUnidad = [];
                          this.activarJefeDependencia();
                        }
                      });
                    } else {
                      this.mostrarMensajeInfo(this._noObjetoGrillaActivar);
                    }


                  }, error => {
                    console.error(error);
                    this.ready();
                  }
                );
              } else {
                this.mostrarMensajeError("No es posible continuar, el usuario no existe en el Sistema GAS, comuníquese con la Dirección de Tecnologías");
              }
            }).catch(error => {
              this.mostrarMensajeError(error);
            });
          } else {

            this.mostrarMensajeError("No es posible continuar, el usuario no existe en el Sistema GAS, comuníquese con la Dirección de Tecnologías");
          }
        }).catch(error => {
          this.mostrarMensajeError(error);
        });


      }
    }
  }

  activarJefeDependencia() {

    this.asociacionJefeDependenciaService.buscarSiDependenciaEstaActivaYEstaActivaParaDependencia(this.jefeUnidadSeleccionado.idUnidad).then(asociacion => {
      if (asociacion) {
        this.lstRespuesta = asociacion;
        if (this.lstRespuesta[0].localeCompare("2") == 0) {
          this.mostrarMensajeError("YA EXISTE UNA PERSONA ACTIVA PARA LA DEPENDENCIA " + this.jefeUnidadSeleccionado.nombreUnidad);
        } else {

          this.jefeUnidadSeleccionado.estaActivoParaDependencia = "S";
          this.personaGuardar.idAsociacionPersona = this.jefeUnidadSeleccionado.idAsociacionPersona;
          this.personaGuardar.idDependencia = this.jefeUnidadSeleccionado.idUnidad + "";
          this.personaGuardar.idPersona = this.jefeUnidadSeleccionado.idPersona;
          this.personaGuardar.estaActivo = "S";
          this.tipoP.idTipoPersona = 1;
          this.personaGuardar.tipoPersona = this.tipoP;
          this.personaGuardar.estaActivoParaDependencia = "S";
          this.personaGuardar.fechaCreacion = this.jefeUnidadSeleccionado.fechaCreacion;
          this.personaGuardar.usuarioCreacion = this.jefeUnidadSeleccionado.usuarioCreacion;

          this.busy = this.asociacionJefeDependenciaService.actualizar(this.personaGuardar).then(asociacion => {
            if (asociacion) {

              const urlUnidad = environment.URL_UNIDADADMINISTRATIVA;
              this.busy = this.cateringUnidadService.buscarPorId(urlUnidad, this.jefeUnidadSeleccionado.idUnidad).then(async unidad => {
                if (unidad) {
                  this.unidadAministrativaActivar = unidad;
                  this.guardarNodosUnidad.push(this.unidadAministrativaActivar);
                  await this.cargaNodosParaActivar();
                  console.log(this.guardarNodosUnidad.length + " tamaño guardar");
                  this.asignaElRolyUnidad();

                }
              }).catch(error => {
                this.mostrarMensajeError("No se encuentra disponible el servicio de listar dependencias, intente más adelante refrescando la pestaña o comuníquese con el administrador");
              });



              //this.obtenerJefesUnidad();
            }
          }).catch(error => {
            this.mostrarMensajeError(error);
          });
        }
      }
    }).catch(error => {
      this.mostrarMensajeError(error);
    });
  }

  desactivarClick() {


    if (!this.jefeUnidadSeleccionado) {
      this.mostrarMensajeInfo(this._noObjetoGrillaDesActivar);
    } else {
      if (this.jefeUnidadSeleccionado.estaActivoParaDependencia.localeCompare("N") == 0) {
        this.mostrarMensajeInfo("Sólo se puede desactivar un registro activo");
      } else {
        this.opcionClick = 3;//esta activado el desactivar


        const urlUsuario = environment.URL_USUARIO;
        this.busy = this.asociacionJefeDependenciaService.buscarPorLdapUid(urlUsuario, this.lstPersonasResultados[0].correoInstitucional.substring(0, this.lstPersonasResultados[0].correoInstitucional.indexOf("@"))).then(async responseU => {
          if (responseU) {
            console.log(responseU);
            this.usuarioGAS = responseU;

            console.log("id persona GAS " + this.usuarioGAS.idUsuario);
            this.busy = this.asociacionJefeDependenciaService.buscarPorLdapUid(urlUsuario, this.usuarioGAS.ldapUid).then(responseU => {
              if (responseU) {
                console.log(responseU);
                this.usuarioPorLdapUid = responseU;
                const URL_USUARIOXROLXUNIDAD = environment.URL_USUARIOXROLXUNIDAD;
                this.busy = this.cateringUnidadService.buscarPorIdAplicativoPorIdUsuario(URL_USUARIOXROLXUNIDAD, environment.APP_ID, this.usuarioPorLdapUid.idUsuario).then(
                  resp => {
                    this.listaUsuarioXRol = [];
                    this.ready();
                    this.listaUsuarioXRolResponse = resp;
                    for (let index = 0; index < this.listaUsuarioXRolResponse.length; index++) {
                      const objUsuaraioXRol: UsuarioXRolXUnidad = this.listaUsuarioXRolResponse[index];

                      if (objUsuaraioXRol.idRol == environment.ROL_JEFE_DEPENDENCIA_ID) {
                        this.listaUsuarioXRol.push(objUsuaraioXRol);
                        console.log("Push");
                      }
                    }

                    if (this.jefeUnidadSeleccionado && this.jefeUnidadSeleccionado.idAsociacionPersona) {
                      this.confirmationService.confirm({
                        key: 'autorizacion',
                        header: this._desactivarJefeDependencia,
                        message: '¿Está seguro que desea desactivar el jefe de dependencia seleccionado?',
                        accept: () => {
                          this.guardarNodosUnidad = [];
                          this.desactivarJefeDependencia();
                        }
                      });
                    } else {
                      this.mostrarMensajeInfo(this._noObjetoGrillaDesActivar);
                    }

                  }, error => {
                    console.error(error);
                    this.ready();
                  }
                );



              } else {
                this.mostrarMensajeError("No es posible continuar, el usuario no existe en el Sistema GAS, comuníquese con la Dirección de Tecnologías");
              }
            }).catch(error => {
              this.mostrarMensajeError(error);
            });


          } else {

            this.mostrarMensajeError("No es posible continuar, el usuario no existe en el Sistema GAS, comuníquese con la Dirección de Tecnologías");
          }
        }).catch(error => {
          this.mostrarMensajeError(error);
        });

      }
    }
  }
  desactivarJefeDependencia() {
    this.jefeUnidadSeleccionado.estaActivoParaDependencia = "N";
    this.personaGuardar.idAsociacionPersona = this.jefeUnidadSeleccionado.idAsociacionPersona;
    this.personaGuardar.idDependencia = this.jefeUnidadSeleccionado.idUnidad + "";
    this.personaGuardar.idPersona = this.jefeUnidadSeleccionado.idPersona;
    this.personaGuardar.estaActivo = "S";
    this.tipoP.idTipoPersona = 1;
    this.personaGuardar.tipoPersona = this.tipoP;
    this.personaGuardar.estaActivoParaDependencia = "N";
    this.personaGuardar.fechaCreacion = this.jefeUnidadSeleccionado.fechaCreacion;
    this.personaGuardar.usuarioCreacion = this.jefeUnidadSeleccionado.usuarioCreacion;

    this.busy = this.asociacionJefeDependenciaService.actualizar(this.personaGuardar).then(async asociacion => {
      if (asociacion) {

        await this.cargaNodosParaEditarELiminar();
        this.asignaElRolyUnidad();
      }
    }).catch(error => {
      this.mostrarMensajeError(error);
    });
  }

  asignaElRolyUnidad() {

    this.standby();
    let objDTO: UsuarioXRolXUnidadDTO = new UsuarioXRolXUnidadDTO();

    let objUxRxU: UsuarioXRolXUnidad = new UsuarioXRolXUnidad();
    objUxRxU.idRol = environment.ROL_JEFE_DEPENDENCIA_ID;
    objUxRxU.estaActivo = true;
    objUxRxU.unidadAdministrativa = null;
    objUxRxU.idAplicativo = environment.APP_ID;
    objUxRxU.usuario = this.usuarioPorLdapUid;
    //console.log(this.usuarioGAS[0].idUsuario, this.usuarioGAS[0].correo + " datos --");

    objDTO.usuarioXRolXUnidad = objUxRxU;

    /**
     * Agrego a la lista del DTO las unidades seleccionadas 
     */
    //this.guardarNodosUnidad
    for (let index = 0; index < this.guardarNodosUnidad.length; index++) {
      //const objUnidadSeleccionada: TreeNode = this.guardarNodosUnidad[index];
      objDTO.unidades.push(this.guardarNodosUnidad[index]);
      console.log("Push " + (index + 1));
    }

    console.log('va mandar con unidade4s ' + objDTO.unidades.length);
    const urlUsuarioXRolXUnidad = environment.URL_USUARIOXROLXUNIDAD;
    if (objDTO.unidades.length > 0) {
      this.standby();

      this.busy = this.asociacionJefeDependenciaService.crearConUnidad(urlUsuarioXRolXUnidad, objDTO).then(
        resp => {
          let obj: UsuarioXRolXUnidadDTO;
          obj = resp;
          this.ready();
          this.mostrarMensajeInfo('SE REALIZÓ CORRECTAMENTE LA OPERACIÓN');
          this.obtenerJefesUnidad();
        }, error => {
          this.ready();
          this.mostrarMensajeError(error);

          if (this.opcionClick == 1) {//si es eliminar tenemos que revertir el eliminar
            this.personaGuardar.estaActivo = "S";
            this.jefeUnidadSeleccionado.estaActivoParaDependencia = "S";
            this.personaGuardar.estaActivoParaDependencia = "S";
          }
          if (this.opcionClick == 2) {//si es activar tenemos que dejar en desactivado
            this.jefeUnidadSeleccionado.estaActivoParaDependencia = "N";
            this.personaGuardar.estaActivoParaDependencia = "N";
            this.personaGuardar.estaActivo = "S";
          }
          if (this.opcionClick == 3) {//si es desactivar tenemos que activar
            this.jefeUnidadSeleccionado.estaActivoParaDependencia = "S";
            this.personaGuardar.estaActivoParaDependencia = "S";
            this.personaGuardar.estaActivo = "S";
          }
          this.personaGuardar.idAsociacionPersona = this.jefeUnidadSeleccionado.idAsociacionPersona;
          this.personaGuardar.idDependencia = this.jefeUnidadSeleccionado.idUnidad + "";
          this.personaGuardar.idPersona = this.jefeUnidadSeleccionado.idPersona;

          this.tipoP.idTipoPersona = 1;
          this.personaGuardar.tipoPersona = this.tipoP;

          this.personaGuardar.fechaCreacion = this.jefeUnidadSeleccionado.fechaCreacion;
          this.personaGuardar.usuarioCreacion = this.jefeUnidadSeleccionado.usuarioCreacion;

          this.busy = this.asociacionJefeDependenciaService.actualizar(this.personaGuardar).then(asociacion => {
            if (asociacion) {
              console.log("Rollback db")
              this.obtenerJefesUnidad();
            }
          }).catch(error => {
            this.mostrarMensajeError(error);
          });

        }
      );
    } else {//le quita el rol porque ya no tendrá asociada ninguna más
      console.log(" ultima quita rol");
      this.quitarRol(urlUsuarioXRolXUnidad, objDTO.usuarioXRolXUnidad);
    }
  }

  /** 
   * Se quita el rol y a todas las unidaddes que tenia
  */
  quitarRol(UsuarioXRolXUnidad, objDTO) {
    try {
      this.asociacionJefeDependenciaService.quitar(UsuarioXRolXUnidad, objDTO).then(
        resp => {
          let obj: String;
          obj = resp;
          this.ready();
          this.mostrarMensajeInfo('SE REALIZÓ CORRECTAMENTE LA OPERACIÓN');
          this.obtenerJefesUnidad();
        }
      );
    } catch (error) {
      console.error('Error clickQuitarRol Detalle:...' + error);
    }

  }

  onRowJefeSelect() {
    /*this.posArrayUsuarioAsociar=-1;
    const urlUsuario = environment.URL_USUARIO;
    this.busy = this.asociacionJefeDependenciaService.buscarPorIdentificacionLdap(urlUsuario, this.jefeUnidadSeleccionado.identificacion).then(responseU => {
      if (responseU) {
        this.usuarioGAS = responseU;
        this.seleccionaElUsuarioParaAsociar();
      }
    }).catch(error => {
      this.mostrarMensajeError("No se puede obtener información del jefe de dependencia para realizar alguna acción asociada");
      this.jefeUnidadSeleccionado=null;
    });*/
    //this.clickBuscarPersonaClaseCriterio();

    this.clickBuscarPersonaClaseCriterio();





  }

  seleccionaElUsuarioParaAsociar() {

    /*for (var h=0;h<this.usuarioGAS.length;h++){
      console.log( "to com"+ this.usuarioGAS[h].nombre.substring(0,this.usuarioGAS[h].nombre.indexOf(" ")));
      console.log( "other"+ (this.usuarioGAS[h].ldapUid.substring(0,this.usuarioGAS[h].ldapUid.indexOf("."))));
      //if (this.usuarioGAS[h].nombre.substring(0,this.usuarioGAS[h].nombre.indexOf(" ")).localeCompare(this.usuarioGAS[h].ldapUid.substring(0,this.usuarioGAS[h].ldapUid.indexOf(".")).toLocaleUpperCase())==0){
      if (this.usuarioGAS[h].ldapUid.toLocaleUpperCase().includes( this.usuarioGAS[h].nombre.substring(0,this.usuarioGAS[h].nombre.indexOf(" ") ))){
        console.log("iguales");
        console.log("UID " +this.usuarioGAS[h].ldapUid);
        this.posArrayUsuarioAsociar=h;        
      }
    }*/
  }

  clickBuscarPersonaClaseCriterio() {
    console.log("buscar " + this.jefeUnidadSeleccionado.identificacion);
    const urlPersona = environment.URL_PERSONA;
    this.lstPersonasResultados = undefined;

    this.busy = this.asociacionJefeDependenciaService.buscarPersonaClaseCriterio(urlPersona, "ADMINISTRATIVO", this.jefeUnidadSeleccionado.identificacion).then(responseBusqueda => {
      this.mensaje = [];
      this.lstPersonasResultados = responseBusqueda;

      this.busy = this.asociacionJefeDependenciaService.buscarPersonaClaseCriterio(urlPersona, "DOCENTE", this.jefeUnidadSeleccionado.identificacion).then(responseBusqueda => {
        this.lstPersonasResultadosDocentes = responseBusqueda;
        this.lstPersonasResultadosDocentes.forEach(async docente => {
          this.flagEncuentraPersona = false;
          await this.buscaPersonaIgual(docente);
          if (!this.flagEncuentraPersona) {
            this.lstPersonasResultados.push(docente);
          }
        });

        this.loadingBusqueda = false;
      }).catch(error => {
        this.loadingBusqueda = false;
        this.mostrarMensajeError(error);
      });
      this.loadingBusqueda = false;
    }).catch(error => {
      this.loadingBusqueda = false;
      this.mostrarMensajeError(error);
    });

    this.loadingBusqueda = true;


  }
  buscaPersonaIgual(docente) {
    this.lstPersonasResultados.forEach(async administrativo => {
      if (docente.identificacion == administrativo.identificacion) {
        this.flagEncuentraPersona = true;
      }
    });
  }
}
